import React, {Component} from 'react';
import ContactLink from "./ContactLink";

import Modal from "react-bootstrap/Modal";

import DisplayMediaComponentProxy from "./DisplayMediaComponentProxy";
import OnlyMediaCarousel from "./OnlyMediaCarousel";
import ContactLinksModal from "./ContactLinksModal";

class OnlyMediaAnnotation extends Component {

    constructor(props) {
        super(props);

        // this.state = {
        //
        // }

    }

    onShow = () => {
        this.setState({
            ...this.props.annotationData
        })


    }


    render() {

            return (

                <div className="annotation-modal">
                    <Modal
                        dialogClassName={"primaryModal modal-dialog annotation-modal-classname modal-dialog-scrollable"}
                        show={this.props.showAnnotationModal} onShow={() => this.onShow()}
                        onHide={this.props.hideAnnotationModal} size={this.props.annotationModalSize} centered={true}
                        backdrop="static">
                        <Modal.Header closeButton style={{border: 'none'}}>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <div className="annotation-main-container-modal">

                                    <DisplayMediaComponentProxy annotationData={this.props.annotationData}  isCarouselUsed={false}/>

                                    {/*<div className="annotation-text-container">*/}
                                    {/*    <div className="annotation-header-text-container"*/}
                                    {/*         dangerouslySetInnerHTML={{__html: this.state.headerText}}>*/}
                                    {/*    </div>*/}
                                    {/*    <div className="annotation-body-text-container"*/}
                                    {/*         style={{textAlign: this.state.annotationTextAlignment,*/}
                                    {/*             lineHeight: this.state.annotationTextLineHeight}}*/}
                                    {/*    >*/}
                                    {/*        <p dangerouslySetInnerHTML={{__html: this.state.bodyText}}></p>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                    {/*<ContactLinksModal key="hasMediaCarouselLink" hasMediaCarouselLink={hasMediaCarouselLink}*/}
                                    {/*                   annotationData={this.props.annotationData}/>*/}
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            )


    }
}

export default OnlyMediaAnnotation;